import React, { Component } from 'react'
import '../../api/FirebaseAuth'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import AgentHeader from './components/AgentHeader/AgentHeader.component'
import AgentFooter from './components/AgentFooter/AgentFooter.component'
import HeroSection from './components/HeroSection/HeroSection.component'
import MeetAgent from './components/MeetAgent/MeetAgent.component'
import TrustBadges from './components/TrustBadges/TrustBadges.component'
import OurMission from './components/OurMission/OurMission.component'
import FaqAccordion from './components/FaqAccordion/FaqAccordion.component'
import ProcessSteps from './components/ProcessSteps/ProcessSteps.component'
import InsuranceProducts from './components/InsuranceProducts/InsuranceProducts.component'
import WhyChoose from './components/WhyChoose/WhyChoose.component'
import ContactForm from './components/ContactForm/ContactForm.component'
import StateLicenses from './components/StateLicenses/StateLicenses.component'
import ProductListing from './components/ProductListing/ProductListing.component'
import InfoBeforeBuying from './components/InfoBeforeBuying/InfoBeforeBuying.component'
import AgentTestimonials from './components/Testimonials/Testimonials'
import SubsiteStore from './stores'
import UserStateLicenseService from '../../shared/services/UserStateLicense.service'
import { defaultTestimonials } from '../WebsiteInfo/stores/WebsiteInfo.store'
import { getHeadline, getMetaDescription, META_KEYWORDS } from './content'
import { getBrandingStyle } from './branding'

import './AgentSubsite.page.scss'

const jsonStrToArray = str => {
  if (Array.isArray(str)) return str

  try {
    if (Array.isArray((str = JSON.parse(str)))) return str
  } catch (ex) {}
  return
}

const setMetaTag = (attr, name, content) => {
  if (!content) return
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

class AgentSubsitePage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      isResolved: false,
      identity: '',
      subsiteData: {},
      licenses: [],
    }
  }

  getSubsiteIdentity() {
    if (
      this.props.match.params.u_login &&
      `${this.props.match.params.u_login}`.toLowerCase().trim() === 'teambanville'
    ) {
      window.location.href = '/jbanville'
      return ''
    }

    return `${this.props.match.params.u_login}`.toLowerCase().trim()
  }

  getPageName() {
    const pageName = this.props.match.params.pageName

    if (
      pageName &&
      ['contact', 'products', 'info-before-buying', 'licenses'].includes(`${pageName}`.trim().toLowerCase())
    )
      return `${pageName}`.trim().toLowerCase()

    return 'home'
  }

  getBannerMessage = () => {
    switch (this.getPageName()) {
      case 'contact':
        return 'Contact Us'
      case 'products':
        return 'Our Products'
      case 'licenses':
        return 'My State Licenses'
      case 'info-before-buying':
        return 'Read Before Purchasing Health Insurance'
      default:
        return 'Welcome'
    }
  }

  renderHome() {
    const { subsiteData } = this.state

    return (
      <>
        <HeroSection subsiteData={subsiteData} />
        <MeetAgent subsiteData={subsiteData} />
        <TrustBadges />
        <OurMission />
        <FaqAccordion subsiteData={subsiteData} />
        <ProcessSteps subsiteData={subsiteData} />
        <InsuranceProducts subsiteData={subsiteData} />
        <WhyChoose />
        {subsiteData.testimonials && subsiteData.testimonials.length ? (
          <AgentTestimonials data={subsiteData} licenses={this.state.licenses} />
        ) : (
          <></>
        )}
      </>
    )
  }

  renderSubPageBody() {
    const { subsiteData } = this.state

    switch (this.getPageName()) {
      case 'contact':
        return <ContactForm subsiteData={subsiteData} />
      case 'products':
        return <ProductListing subsiteData={subsiteData} />
      case 'licenses':
        return <StateLicenses licenses={this.state.licenses} subsiteData={subsiteData} />
      case 'info-before-buying':
        return <InfoBeforeBuying subsiteData={subsiteData} />
      default:
        return <></>
    }
  }

  componentDidMount() {
    this.setState({ identity: this.getSubsiteIdentity() }, () => {
      this.fetchAgentData().finally(() => {
        this.setState({ isResolved: true })
        this.setPage()
      })
    })
  }

  componentDidUpdate() {
    SubsiteStore.sendPageView(this.props.location?.pathname)
  }

  setPage = () => {
    const { subsiteData } = this.state
    const pageName = this.getPageName()

    // Document title --------------------------------------------------------
    const name = [subsiteData?.u_nickname ? subsiteData?.u_nickname : subsiteData?.u_fname, subsiteData?.u_lname]
      .filter(n => n)
      .join(' ')
      .trim()

    let title
    if (pageName === 'home') {
      title = [getHeadline(subsiteData), name].filter(n => n).join(' | ')
    } else {
      title = ['USABG', name, this.getBannerMessage()].filter(n => n).join(' - ')
    }
    document.title = title

    // SEO meta tags ---------------------------------------------------------
    const description = getMetaDescription(subsiteData)
    setMetaTag('name', 'description', description)
    setMetaTag('name', 'keywords', META_KEYWORDS)
    setMetaTag('property', 'og:title', title)
    setMetaTag('property', 'og:description', description)
    setMetaTag('property', 'og:type', 'website')

    SubsiteStore.sendPageView(this.props.location?.pathname)
  }

  fetchAgentData = async () => {
    this.setState({ isLoading: true })
    return AdminApi.getUserWebsiteDetailsByUlogin(this.state.identity)
      .then(result => {
        if (result?.data?.data) {
          const subsiteData = {
            ...result.data.data,
            prefix: result.data.imageUrl.prefix,
            suffix: result.data.imageUrl.suffix,
          }

          subsiteData.testimonials = jsonStrToArray(result?.data?.data?.testimonials)
          subsiteData.testimonials =
            !subsiteData.testimonials || subsiteData.testimonials.length === 0
              ? defaultTestimonials
              : subsiteData.testimonials
          subsiteData.menu_links = jsonStrToArray(result?.data?.data?.menu_links) || []
          subsiteData.resource_links = jsonStrToArray(result?.data?.data?.resource_links) || []

          SubsiteStore.set(subsiteData)
          this.setState({ subsiteData })

          UserStateLicenseService.search({
            search: { user_id: subsiteData.user_id },
            pagination: false,
          }).then(
            r => {
              this.setState({
                subsiteData,
                isLoading: false,
                licenses: r.models.sort(
                  (a, b) => a.state_abrev && `${a.state_abrev}`.localeCompare(b.state_abrev, 'en')
                ),
              })
            },
            () => this.setState({ isLoading: false })
          )
        }
        if (result.data.script) {
          const scriptDom = document.getElementById('site-script')
          if (scriptDom) {
            scriptDom.parentNode.removeChild(scriptDom)
          }
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.id = 'site-script'
          script.innerHTML = atob(result.data.script)
          document.body.appendChild(script)
        }
        return true
      })
      .catch(error => {
        toast.error('User not found', { position: toast.POSITION.TOP_RIGHT })
        this.setState({ isLoading: false })
        window.location.href = '/'
        return false
      })
  }

  render() {
    toast.configure()
    const { subsiteData, isResolved } = this.state
    const isHome = this.getPageName() === 'home'

    return (
      <div
        id='AgentSubsitePage'
        className={isResolved ? 'is-resolved' : 'is-resolving'}
        style={getBrandingStyle(subsiteData)}
      >
        <AgentHeader subsiteData={subsiteData} isResolved={isResolved} />
        {isHome ? (
          this.renderHome()
        ) : (
          <>
            <section className='subsite-page-hero'>
              <h1>{this.getBannerMessage()}</h1>
            </section>
            <section className='subsite-subpage'>
              <div className='subsite-shell'>
                <div className='subsite-subpage-card'>{this.renderSubPageBody()}</div>
              </div>
            </section>
          </>
        )}
        <AgentFooter subsiteData={subsiteData} isResolved={isResolved} goTo={link => this.props.history.push(link)} />
      </div>
    )
  }
}

export default AgentSubsitePage
